module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理户外招牌设置备案","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广州市户外招牌设置备案信息表 （店招牌匾）","state":"必要"},{"name":"2、广州市户外招牌设置备案信息表（楼名招牌）","state":"非必要"},{"name":"3、广州市户外招牌设置和维护安全告知承诺书","state":"非必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx35.json
// module id = 1332
// module chunks = 0